import { AutogenModelHandlingRequirementLookup, AutogenRowHandlingRequirementLookup } from "./autogen/AutogenModelHandlingRequirementLookup";

export class ModelHandlingRequirementLookup extends AutogenModelHandlingRequirementLookup<RowHandlingRequirementLookup> {
	constructor() {
		super(RowHandlingRequirementLookup);
	}
}

export class RowHandlingRequirementLookup extends AutogenRowHandlingRequirementLookup {
}